import { render, staticRenderFns } from "./WikiArchiveConfig.vue?vue&type=template&id=82ee78b2"
import script from "./WikiArchiveConfig.vue?vue&type=script&lang=ts"
export * from "./WikiArchiveConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports